import dayjs from "@/lib/day";
import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";

export const typeDef = gql`
  type ProductOrders @cacheControl(maxAge: 0) {
    order_id: Int
    name: String
    created_at: String
    order: OrderType
    entitlements: [Entitlement]
  }
  type ProductOrdersResponse {
    data: [ProductOrders]
  }

  type OrderType {
    finished_at: String
    payment_amount: Int
    payment_instrument: paymentInstrumentType
  }

  type paymentInstrumentType {
    payment_method_id: Int
    values: paymentInstrumentValue
  }

  type paymentInstrumentValue {
    card_type: String
    card_number: String
  }

  type orderValue {
    product_price: Int
    discount_name: String
    transaction_start_at: String
  }

  type OrderData @cacheControl(maxAge: 0) {
    name: String
    payment_amount: Int
    payment_instrument: paymentInstrumentType
    values: orderValue
    created_at: String
    order_type: String
  }

  type OrdersResult {
    data: [OrderData]
    pageInfo: PageInfo
  }

  type Query {
    productOrders(
      with_order: Boolean
      with_payment_instrument: Boolean
      with_entitlements: Boolean
      type: String
    ): ProductOrdersResponse

    orders(offset: Int, limit: Int, year: Int): OrdersResult
  }
`;

export const resolvers = {
  Query: {
    productOrders: async (_parent, args, { req, dataSources }) => {
      let result = await dataSources.orders.getProductOrders(args);
      const now = dayjs();
      if (args.type === "is-entitled") {
        result.product_orders = result.product_orders.filter((element) => {
          if (
            element.product.values.adult_flag === false &&
            element?.entitlements?.length !== 0 &&
            !element?.entitlements?.[0]?.end_at
          ) {
            return true;
          } else if (
            element.product.values.adult_flag === false &&
            element?.entitlements?.length !== 0 &&
            element?.entitlements?.[0]?.end_at
          ) {
            return dayjs(element?.entitlements?.[0]?.end_at).isAfter(now);
          }
        });
      }
      return {
        data: result.product_orders,
      };
    },
    orders: async (_parent, args, { dataSources }) => {
      const res = await dataSources.user.userOrders(args);

      console.log("orders", res);
      return {
        data: res.orders,
        pageInfo: createPageInfo({ ...args, count: res.total_count }),
      };
    },
  },
};
